import { LimitTypes } from 'content-management-restrictions-lib';
export const LANDING_PAGES_LIMIT_NAME_TO_LIMIT_TYPE_MAP = {
  'cms-landing-pages': LimitTypes.CONTENT_OBJECT_LIMIT,
  'cms-landing-pages-multi-language': LimitTypes.CONTENT_OBJECT_MULTI_LANG_GROUP_SIZE_LIMIT
};
export const SITE_PAGES_LIMIT_NAME_TO_LIMIT_TYPE_MAP = {
  'cms-site-pages': LimitTypes.CONTENT_OBJECT_LIMIT,
  'cms-site-pages-multi-language': LimitTypes.CONTENT_OBJECT_MULTI_LANG_GROUP_SIZE_LIMIT
};